import Vue from 'vue'
import vuex from 'vuex'

Vue.use(vuex);

export default new vuex.Store({
    state:{
      defaultActiveIndex:'/',
      worktab: {
        list: [

        ],
        current: {
        }
      },
      closingPage: [],
      realClose:['checkRecord', 'addBanner', 'add_activityManagement', 'addOrEditSendActivity', 'downRoleType', 'score_detail', 'user_detail', 'add_good', "editUpLog", 'editNormalUser', 'addNormalUser', 'companySet', 'editUpRule', 'addCourse']
    },
    mutations:{
      jumpTo(state, url){
        state.defaultActiveIndex = url
      },
      worktabRemove (state, p) {
        // 关闭标签
        let ind = state.worktab.list.findIndex(s => s.name === p.name)
        if (ind > -1) {
          // 清理 keep alive - start
          // 清理 keep alive - end
          let ind1 = state.closingPage.findIndex(s => s === p.name)
          if (ind1 == -1) {
            state.closingPage.push(state.worktab.list[ind].name);
          }
          state.worktab.list.splice(ind, 1);
        }
        if (p.name === state.worktab.current.name) {
          // 是当前页，返回上一页
          if (state.worktab.list.length == 0)
          {
            p.router.push('/')
          } else if ((ind - 1) > 0) {
            p.router.push(state.worktab.list[ind-1].name)
          } else
          {
            p.router.push(state.worktab.list[0].name)
          }
        }
      },
      worktabRoute (state, p) {
        if (state.realClose.findIndex(s => s.name === p.to.name) > -1)
        {
          return
        }
        let ind = state.worktab.list.findIndex(s => s.name === p.to.name);
        if (ind > -1) {
          // 标签已存在
          state.worktab.current = state.worktab.list[ind];

        } else {
          // 标签不存在，现在新建
          state.worktab.list.push(p.to)
          state.worktab.current = p.to;
          let ind1 = state.closingPage.findIndex(s => s === p.to.name)
          if (ind1 > -1) {
            state.closingPage.splice(ind1, 1);
          }
        }
          // state.closingPage = ''
        }
      },
    actions: {
      worktabRemove ({commit}, p) {
      commit('worktabRemove', p)
      },
      worktabRoute ({commit}, p) {
        commit('worktabRoute', p)
      }
    }

})



// WEBPACK FOOTER //
// ./src/vuexStore.js